import React from "react"

import * as S from "./styled"

const Hero = props => {
  const fullPath = `https://gendo.com.br/blog`
  const data = props.postList.map(
    (
      {
        node: {
          frontmatter: { category, description, image, title },
          fields: { slug },
        },
      },
      index
    ) =>
      index < 3 && (
        <S.HeroLink
          to={slug}
          image={image ? fullPath + image.childImageSharp.resize.src : ""}
          key={index}
        >
          <S.HeroPostWrapper>
            <S.HeroPostInfo>
              <span>{category}</span>
            </S.HeroPostInfo>
            <S.HeroPostInfo>
              <S.HeroPostTitle>{title}</S.HeroPostTitle>
              <S.HeroPostDescription>{description}</S.HeroPostDescription>
            </S.HeroPostInfo>
          </S.HeroPostWrapper>
        </S.HeroLink>
      )
  )

  return (
    <S.Hero>
      <S.HeroContainer>
        <S.HeroItemShowcase> {data[0]} </S.HeroItemShowcase>
      </S.HeroContainer>

      <S.HeroContainer>
        <S.HeroItem>
          {data[1]}
          {data[2]}
        </S.HeroItem>
      </S.HeroContainer>
    </S.Hero>
  )
}

export default Hero
